import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Survey from '../components/Survey/Survey';

/**
 * Embed page for the widget
 * Loaded inside iframe from embed.js
 */
const Embed = () => {
  const [searchParams] = useSearchParams();
  const district = searchParams.get('district');
  const surveyTitle = searchParams.get('title') || 'Career Interest Survey';
  const surveyMessage = searchParams.get('message') || 'Discover your career interests and find the right path for your future';

  // Parse footer config from URL parameter
  let footerConfig = null;
  const footerParam = searchParams.get('footer');
  if (footerParam) {
    try {
      footerConfig = JSON.parse(footerParam);
    } catch (e) {
      console.error('Failed to parse footer config:', e);
    }
  }

  if (!district) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Configuration Error</h2>
          <p className="text-gray-600">District parameter is required to load the survey.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Survey
        districtProp={district}
        embedded={true}
        customTitle={surveyTitle}
        customMessage={surveyMessage}
        footerConfig={footerConfig}
      />
    </div>
  );
};

export default Embed;
